/**
 * @file API для загрузки параметров Field0 из Mirror API
 * @module membrane/src/visual/field0/field0Api
 * 
 * Загружает параметры поля из Mirror API и преобразует их в формат Field0Params.
 */

import { getField } from '../../services/mirrorApi';
import { Field0Params, DEFAULT_FIELD_PARAMS } from './field0Params';

/**
 * Загружает параметры поля из Mirror API
 * @param seed - seed для вариативности
 * @returns параметры поля
 */
export async function loadFieldParams(seed?: string): Promise<Field0Params> {
  try {
    const fieldData = await getField(seed);
    console.log('Field data from API:', fieldData);
    
    // Преобразуем данные из Mirror API в формат Field0Params
    const params: Field0Params = {
      seed: fieldData.seed || Date.now(),
      energy: fieldData.energy ?? DEFAULT_FIELD_PARAMS.energy,
      turbulence: fieldData.turbulence ?? DEFAULT_FIELD_PARAMS.turbulence,
      cohesion: fieldData.cohesion ?? DEFAULT_FIELD_PARAMS.cohesion,
      drift: fieldData.drift ?? DEFAULT_FIELD_PARAMS.drift,
      palette: Array.isArray(fieldData.palette?.colors) 
        ? fieldData.palette.colors
        : (fieldData.palette && typeof fieldData.palette === 'object' && !Array.isArray(fieldData.palette)
          ? DEFAULT_FIELD_PARAMS.palette
          : (Array.isArray(fieldData.palette) ? fieldData.palette : DEFAULT_FIELD_PARAMS.palette)),
      layers: Array.isArray(fieldData.layers) && fieldData.layers.length > 0
        ? fieldData.layers
        : DEFAULT_FIELD_PARAMS.layers,
    };
    
    console.log('Parsed field params:', params);
    return params;
  } catch (error) {
    console.warn('Failed to load field params from Mirror API, using defaults:', error);
    console.log('Using default params:', DEFAULT_FIELD_PARAMS);
    return DEFAULT_FIELD_PARAMS;
  }
}

